// Reading time + heading extraction helpers (client-side, no deps).

export function readingTime(...texts) {
  const words = texts
    .filter(Boolean)
    .join(" ")
    .replace(/<[^>]+>/g, " ")
    .trim()
    .split(/\s+/)
    .filter(Boolean).length;
  return Math.max(1, Math.round(words / 200));
}

export function slugifyHeading(text) {
  return (
    "sec-" +
    (text || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "")
      .slice(0, 60)
  );
}

export function extractHeadings(html) {
  if (typeof window === "undefined" || !html) return [];
  const doc = new DOMParser().parseFromString(html, "text/html");
  return [...doc.querySelectorAll("h2, h3")]
    .map((h) => ({ id: slugifyHeading(h.textContent), text: (h.textContent || "").trim(), level: h.tagName === "H2" ? 2 : 3 }))
    .filter((h) => h.text);
}

export function addHeadingIds(html) {
  if (typeof window === "undefined" || !html) return html;
  const doc = new DOMParser().parseFromString(`<div id="rc-hid">${html}</div>`, "text/html");
  doc.querySelectorAll("h2, h3").forEach((h) => {
    const t = (h.textContent || "").trim();
    if (t) {
      h.id = slugifyHeading(t);
      h.classList.add("scroll-mt-24");
    }
  });
  const root = doc.getElementById("rc-hid");
  return root ? root.innerHTML : html;
}
